import React from "react";
import DropdownButton from "./DropdownButton";
import {alert} from "devextreme/ui/dialog";

const FilterByColor = props => {
    const {gridInstance, objectName = "Color"} = props;
    const sortDataSource = [
        {cssImage: "dot dot-color", Color: "", text: "Clear Sort", id: "0"},
        {cssImage: "dot dot-color1", Color: "#D2E2FF", text: "Azureish White", id: "#D2E2FF"},
        {cssImage: "dot dot-color2", Color: "#FEE8B3", text: "Peach", id: "#FEE8B3"},
        {cssImage: "dot dot-color3", Color: "#B1E3CE", text: "Magic Mint", id: "#B1E3CE"},
        {cssImage: "dot dot-color4", Color: "#D4D4D4", text: "Light Gray", id: "#D4D4D4"},
        {cssImage: "dot dot-color5", Color: "#FFCFAF", text: "Apricot", id: "#FFCFAF"},
        {cssImage: "dot dot-color6", Color: "#EDD7FF", text: "Lavender", id: "#EDD7FF"},
        {cssImage: "dot dot-color7", Color: "#FFA7A7", text: "Salmon Pink", id: "#FFA7A7"}]
    const filterDataSource = [
        {cssImage: "dot dot-color", Color: "", text: "Show all", id: "0"},
        {cssImage: "dot dot-color1", Color: "#D2E2FF", text: "Azureish White", id: "#D2E2FF"},
        {cssImage: "dot dot-color2", Color: "#FEE8B3", text: "Peach", id: "#FEE8B3"},
        {cssImage: "dot dot-color3", Color: "#B1E3CE", text: "Magic Mint", id: "#B1E3CE"},
        {cssImage: "dot dot-color4", Color: "#D4D4D4", text: "Light Gray", id: "#D4D4D4"},
        {cssImage: "dot dot-color5", Color: "#FFCFAF", text: "Apricot", id: "#FFCFAF"},
        {cssImage: "dot dot-color6", Color: "#EDD7FF", text: "Lavender", id: "#EDD7FF"},
        {cssImage: "dot dot-color7", Color: "#FFA7A7", text: "Salmon Pink", id: "#FFA7A7"}]

    const filterRowsByColor = e => {
        if (e.id === "0") {
            gridInstance.current?.instance().clearFilter()
            return
        }
        gridInstance.current?.instance().filter([objectName, "=", e.id])

    }

    const sortRowsByColor = e => {
        if (e.id === "0") {
            gridInstance.current?.instance().columnOption(objectName, {
                sortOrder: undefined,
                calculateSortValue: undefined
            });
            gridInstance.current?.instance().refresh()
            return
        }
        gridInstance.current?.instance().columnOption(objectName, {
            sortIndex: 0,
            sortOrder: "asc",
            calculateSortValue: row => row[objectName]?.toLowerCase() === e.id.toLowerCase() ? 0 : 1
        });
        gridInstance.current?.instance().refresh()
    }

    const dropdownItems = [{
        id: "filter",
        text: "Filter By Color",
        icon: "/svg/filter.svg",
        children: filterDataSource
    }, {
        id: "sort",
        text: "Sort By Color",
        icon: "/svg/switch-vertical.svg",
        children: sortDataSource
    }]

    return (<div className="me-3">
        <DropdownButton
            // label="Filter & Sort"
            icon="/svg/filter.svg"
            items={dropdownItems}
            variant="default"
            buttonClassName="px-3"
            parentClick={(option) => {

            }}
            childClick={(option, parent) => {
                if (parent.id === "filter")
                    filterRowsByColor(option)
                else if (parent.id === "sort")
                    sortRowsByColor(option)
                else
                    return alert("Invalid operation.", "Warning!")
            }}
        />
    </div>)

}

export default FilterByColor;